<template>
  <div
    @contextmenu="onShowContextMenu"
    :id="model.$ID"
    :class="['dr-expansion-panel-editor-mode', evaluateClasses(classes)]"
  >
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="deletePanel">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="readonly" v-on="on" text color="success" @click="onAddPanelItem">
            <font-awesome-icon :icon="['fal', 'plus']" size="lg" />
            <font-awesome-icon :icon="['fal', 'grip-vertical']" size="lg" />
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.dr-expansion-panel.addPanel") }}</span>
      </v-tooltip>
    </portal>
    <v-container fluid class="pa-0" v-if="isInEditorMode">
      <div :class="[ {'dr-expansion-panel-selected': isSelected} ]">
        <div 
          class="expansion-panel-header d-flex justify-center align-center"
          @click.stop="selectComponent(model)">
            Expansion panel
        </div>
        <v-expansion-panels v-model="panels" :multiple="model.Multiple" class="dr-expansion-panel-container">
          <dr-expansion-panel-item 
            class="dr-expansion-panel-editor-mode-items"
            v-for="(panelItem, index) in panelItems" :key="index" 
            :model="panelItem"
            :parentsWidgets="currentListOfParentsWidgets"
            @onDeletePanelItem="onDeletePanelItem"
            @modelChanged="onModelChanged"
            :dataSource="dataSource"
            @callDataSourceAction="$emit('callDataSourceAction', $event)"
          />
        </v-expansion-panels>
      </div>
      <widgets-context-menu
        v-if="isInEditorMode"
        v-model="showContextMenu"
        :x="x"
        :y="y"
        :snippetCreatable="false"
        :widgetModel="model"
        @deleteComponent="onDeleteComponentFromContextMenu"
        @pasteCopiedWidget="onPasteCopiedWidget"
      />
    </v-container>
  </div>
</template>
<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'

export default {
  mixins: [mixin, contextMenuMixin, inputMixin],
  data: () => ({
    panels: []
  }),
  components: {
    'dr-expansion-panel-item': () => import('./dr-expansion-panel-item.vue')
  },
  computed: {
    panelItems() {
      return this.model.PanelItems || []
    }
  },
  methods: {
    onDeletePanelItem(panelItem) {
      const index = this.model.PanelItems.indexOf(panelItem)
      if (index === -1) {
        return
      }
      this.model.PanelItems.splice(index, 1)
      this.onModelChanged()
    },
    onAddPanelItem() {
      let newPanelItem = {
        $ID: Math.random() + '',
        $Type: 'dr-expansion-panel-item',
        Text: `Panel item${this.model.PanelItems.length}`,
        Widgets: []
      }
      this.model.PanelItems.push(newPanelItem)
      this.onModelChanged()
    },
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    deletePanel() {
      this.$emit('deleteComponent', this.model)
    }
  }
}
</script>
<style>
  .dr-expansion-panel-editor-mode{
    border: 1px solid #a9a9a9;
    margin: 5px 0;
  }
  .expansion-panel-header {
    text-align: center;
    background-color: #f0f0f0;
    border-bottom: 1px solid darkgrey;
    height: 15px;
    font-size: 0.7em;
  }
  .dr-expansion-panel-selected {
    outline: 2px solid #ffa500;
    outline-offset: -2px;
  }
  .v-expansion-panels {
    margin-left: 2px;
    padding-right: 4px;
  }

  .dr-expansion-panel-container {
    padding-bottom: 3px;
  }
  
</style>